// Menções nas notas: escrever «@» mostra a equipa; ao gravar, cada pessoa mencionada recebe uma tarefa no HUB
// (com link para o projeto) e um email. Usado nas notas do projeto e nas notas das fases.
import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabase';

let cacheEquipa = null;
async function equipa() {
  if (cacheEquipa) return cacheEquipa;
  const { data } = await supabase.from('user_roles').select('email,full_name,active').order('full_name');
  cacheEquipa = (data || []).filter(u => u.active !== false && u.email && u.full_name).map(u => ({ email: String(u.email).toLowerCase(), nome: u.full_name }));
  return cacheEquipa;
}
const sem = (s) => String(s || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase();

// quem está mencionado no texto: «@Nome Completo» ou «@Primeironome» (se não houver dúvida)
export async function mencionados(texto) {
  const eq = await equipa();
  const t = sem(texto);
  const achados = new Map();
  eq.forEach(u => { if (t.includes('@' + sem(u.nome))) achados.set(u.email, u); });
  const curtos = [...String(texto).matchAll(/@([A-Za-zÀ-ÿ]+)/g)].map(m => sem(m[1]));
  curtos.forEach(c => {
    const cand = eq.filter(u => sem(u.nome).split(' ')[0] === c);
    if (cand.length === 1) achados.set(cand[0].email, cand[0]);
  });
  return [...achados.values()];
}

const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// link/botao/semDe: para usar fora dos projetos (ex.: notas das tarefas → link para a tarefa)
export async function notificarMencoes({ texto, autorNome, autorEmail, projetoId, projetoNome, onde, link: linkDado, botao, semDe }) {
  let pessoas = [];
  try { pessoas = await mencionados(texto); } catch (_) { return 0; }
  const eu = String(autorEmail || '').toLowerCase();
  const autorTxt = autorNome || autorEmail || 'Alguém da equipa';
  const hoje = new Date().toISOString().slice(0, 10);
  const link = linkDado || (projetoId ? `/projetos/${projetoId}` : null);
  const ref = projetoNome ? (semDe ? ` «${projetoNome}»` : ` de «${projetoNome}»`) : '';
  const refHtml = projetoNome ? `${semDe ? ' ' : ' de '}<b>${esc(projetoNome)}</b>` : '';
  let n = 0;
  for (const p of pessoas) {
    if (p.email === eu || sem(p.nome) === sem(autorNome)) continue;
    const resumo = String(texto).length > 160 ? String(texto).slice(0, 157) + '…' : String(texto);
    try {
      await supabase.from('tarefas').insert({
        texto: `${autorTxt} mencionou-te ${onde || 'numa nota'}${ref}: «${resumo}»`,
        responsavel_email: p.email, responsavel_nome: p.nome, autor_email: eu || null, autor_nome: autorTxt,
        data_lembrete: hoje, prioridade: 'Normal', link,
      });
      const corpo = {
        to: p.email, toName: p.nome, fromName: 'Workwell HUB',
        subject: `${autorTxt} mencionou-te${projetoNome ? ' — ' + projetoNome : ''}`,
        html: `<div style="font-family:Helvetica,Arial,sans-serif;max-width:520px;margin:0 auto;padding:24px;color:#1A1A2E">
<div style="background:#691FB1;border-radius:12px 12px 0 0;padding:16px 22px"><span style="color:#fff;font-size:16px;font-weight:700">💬 Foste mencionado</span></div>
<div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:22px;font-size:14px;line-height:1.6">
<p style="margin:0 0 10px">${esc(autorTxt)} mencionou-te ${esc(onde || 'numa nota')}${refHtml}:</p>
<div style="background:#FAF8FF;border-left:3px solid #691FB1;border-radius:6px;padding:12px 14px;white-space:pre-wrap">${esc(texto)}</div>
${link ? `<p style="margin:18px 0 0"><a href="https://hub.workwell.pt${link}" style="background:#691FB1;color:#fff;text-decoration:none;padding:10px 18px;border-radius:8px;font-weight:600;display:inline-block">${esc(botao || 'Abrir o projeto')}</a></p>` : ''}
</div></div>` };
      // tenta duas vezes: invoke não lança erro, devolve-o
      for (let i = 0; i < 2; i++) {
        const { error } = await supabase.functions.invoke('Send-email', { body: corpo });
        if (!error) break;
        console.warn('Aviso de menção não enviado', p.email, error);
      }
      n++;
    } catch (_) { /* a nota fica gravada mesmo que o aviso falhe */ }
  }
  return n;
}

// caixa de texto com sugestões ao escrever «@»
export function CampoMencoes({ value, onChange, onEnter, placeholder, style }) {
  const [eq, setEq] = useState([]);
  const [sug, setSug] = useState([]);
  const ref = useRef(null);
  useEffect(() => { equipa().then(setEq).catch(() => {}); }, []);
  const atualizar = (v) => {
    onChange(v);
    const pos = ref.current ? ref.current.selectionStart : v.length;
    const m = v.slice(0, pos).match(/@([A-Za-zÀ-ÿ ]{0,30})$/);
    if (!m) { setSug([]); return; }
    const q = sem(m[1]).trim();
    setSug(eq.filter(u => !q || sem(u.nome).includes(q)).slice(0, 6));
  };
  const escolher = (u) => {
    const pos = ref.current ? ref.current.selectionStart : value.length;
    const antes = value.slice(0, pos).replace(/@([A-Za-zÀ-ÿ ]{0,30})$/, '@' + u.nome + ' ');
    onChange(antes + value.slice(pos));
    setSug([]);
    setTimeout(() => ref.current && ref.current.focus(), 0);
  };
  return (
    <div style={{ position:'relative', flex:1 }}>
      <input ref={ref} value={value} onChange={e=>atualizar(e.target.value)} placeholder={placeholder}
        onKeyDown={e=>{ if (e.key === 'Enter') { if (sug.length) { e.preventDefault(); escolher(sug[0]); } else onEnter && onEnter(); } if (e.key === 'Escape') setSug([]); }}
        style={{ ...style, width:'100%', boxSizing:'border-box' }}/>
      {sug.length > 0 && (
        <div style={{ position:'absolute', top:'100%', left:0, zIndex:50, background:'#fff', border:'1px solid #E4DEFA', borderRadius:8, boxShadow:'0 6px 18px rgba(105,31,177,.15)', marginTop:2, minWidth:220 }}>
          {sug.map(u => (
            <div key={u.email} onMouseDown={e=>{ e.preventDefault(); escolher(u); }}
              style={{ padding:'7px 10px', fontSize:12.5, cursor:'pointer', borderBottom:'1px solid #F4F1FB' }}>
              <b>{u.nome}</b> <span style={{ color:'#8888AA', fontSize:11 }}>{u.email}</span>
            </div>))}
        </div>)}
    </div>);
}
